/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import DashboardSidebar from "../sidebar/sidebar.jsx";
// import HeaderTwo from "../../fandashboard/newHeaderTwo.jsx";
import Footer from "../../home/footer.jsx";
import { TagsInput } from "react-tag-input-component";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
import {
  updateUserProfile,
  getCurrentUser,
  storeAuthData,
  getUserProfile
} from "../../../services/authService";
import { toast } from "react-toastify";
import Navbar from "../../landingpage/sections/Navbar/index.jsx";

// Cloudinary configuration
const CLOUD_NAME = "dcyzivpw4";
const UPLOAD_PRESET = "howzitone";

const Profile = (props) => {
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [profileData, setProfileData] = useState({
    fullName: "",
    userPhone: "",
    profilepicture: "",
    email: "",
    dob: "",
    favoriteentertainment: [],
    socialmedialinks: []
  });

  useEffect(() => {
    loadUserProfile();
  }, []);

  const loadUserProfile = async () => {
    try {
      setLoading(true);
      const userData = getCurrentUser();

      if (userData) {
        const userId = userData._id || userData.id || userData.userId;

        if (userId) {
          const response = await getUserProfile(userId);

          if (response.success && response.data) {
            const userProfile = response.data;
            setProfileData({
              fullName: userProfile.fullName || "",
              userPhone: userProfile.userPhone || "",
              profilepicture: userProfile.profilepicture || "",
              email: userProfile.email || "",
              dob: userProfile.dob ? userProfile.dob.split('T')[0] : "",
              favoriteentertainment: userProfile.favoriteentertainment || [],
              socialmedialinks: userProfile.socialmedialinks || []
            });

            storeAuthData(localStorage.getItem('token'), userProfile);
          } else {
            setLocalStorageData(userData);
          }
        } else {
          setLocalStorageData(userData);
        }
      } else {
        throw new Error('User not found in localStorage');
      }
    } catch (error) {
      console.error("Error loading profile:", error);
      const userData = getCurrentUser();
      if (userData) {
        setLocalStorageData(userData);
      }
    } finally {
      setLoading(false);
    }
  };

  const setLocalStorageData = (userData) => {
    setProfileData({
      fullName: userData.fullName || "",
      userPhone: userData.userPhone || "",
      profilepicture: userData.profilepicture || "",
      email: userData.email || "",
      dob: userData.dob ? (typeof userData.dob === 'string' ? userData.dob.split('T')[0] : userData.dob) : "",
      favoriteentertainment: userData.favoriteentertainment || [],
      socialmedialinks: userData.socialmedialinks || []
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check if file is an image
    if (!file.type.startsWith('image/')) {
      toast.error('Please select an image file');
      return;
    }

    // Restrict to only JPG and PNG
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Please select only JPG or PNG images. SVG files are not allowed.');
      return;
    }

    // Check file extension as additional safety
    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && !fileName.endsWith('.png')) {
      toast.error('Please select only JPG or PNG images. SVG files are not allowed.');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image size should be less than 5MB');
      return;
    }

    setUploading(true);

    try {
      const imageUrl = await uploadImageToCloudinary(file);
      setProfileData(prev => ({
        ...prev,
        profilepicture: imageUrl
      }));
      toast.success('Profile picture uploaded successfully!');
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error.message || 'Failed to upload image');
    } finally {
      setUploading(false);
    }
  };

  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (!file.type.startsWith('image/')) {
  //     toast.error('Please select an image file');
  //     return;
  //   }

  //   if (file.size > 5 * 1024 * 1024) {
  //     toast.error('Image size should be less than 5MB');
  //     return;
  //   }

  //   setUploading(true);

  //   try {
  //     const imageUrl = await uploadImageToCloudinary(file);
  //     setProfileData(prev => ({
  //       ...prev,
  //       profilepicture: imageUrl
  //     }));
  //     toast.success('Profile picture uploaded successfully!');
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //     toast.error(error.message || 'Failed to upload image');
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const uploadImageToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("folder", "howzit/profiles");

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error?.message || 'Upload failed');
    }

    if (data.secure_url) {
      return data.secure_url;
    } else {
      throw new Error('Upload failed: No URL returned');
    }
  };

  const handleSocialLinkChange = (index, field, value) => {
    const updatedLinks = [...profileData.socialmedialinks];
    updatedLinks[index] = {
      ...updatedLinks[index],
      [field]: value
    };
    setProfileData(prev => ({
      ...prev,
      socialmedialinks: updatedLinks
    }));
  };

  const addSocialLink = () => {
    setProfileData(prev => ({
      ...prev,
      socialmedialinks: [...prev.socialmedialinks, { platform: "", url: "" }]
    }));
  };

  const removeSocialLink = (index) => {
    setProfileData(prev => ({
      ...prev,
      socialmedialinks: prev.socialmedialinks.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const updateData = {
        fullName: profileData.fullName,
        userPhone: profileData.userPhone,
        profilepicture: profileData.profilepicture,
        email: profileData.email,
        dob: profileData.dob,
        favoriteentertainment: profileData.favoriteentertainment,
        socialmedialinks: profileData.socialmedialinks.filter(link =>
          link.platform && link.url
        )
      };

      console.log("Sending data:", updateData);

      const response = await updateUserProfile(updateData);
      if (response.success) {
        const currentUser = getCurrentUser();
        const updatedUser = { ...currentUser, ...response.data };
        storeAuthData(localStorage.getItem('token'), updatedUser);
        toast.success("Profile updated successfully!");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.message || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar {...props} />
      {/* Breadcrumb */}
      <div className="breadcrumb-bar"
        style={{
          backgroundColor: 'var(--breadcrumb-bg)',
          transition: 'background-color 0.3s ease'
        }}
      >
        <div className="container">
          <div className="row align-items-center inner-banner">
            <div className="col-md-12 col-12 text-center">
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">
                      <i className="isax isax-home-15" />
                    </a>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Fan
                  </li>
                  <li className="breadcrumb-item active">Fan Profile</li>
                </ol>
                <h2 className="breadcrumb-title">Fan Profile</h2>
              </nav>
            </div>
          </div>
        </div>
        <div className="breadcrumb-bg">
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-01.png"
            alt="img"
            className="breadcrumb-bg-01"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-02.png"
            alt="img"
            className="breadcrumb-bg-02"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-03"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-04"
          />
        </div>
      </div>

      {/* Page Content */}
      <div className="content doctor-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-xl-3 theiaStickySidebar">
              <DashboardSidebar />
            </div>
            <div className="col-lg-8 col-xl-9">
              <div className="dashboard-header">
                <h3>Profile Settings</h3>
              </div>

              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading profile...</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  {/* Profile Image */}
                  <div className="setting-title">
                    <h5>Profile</h5>
                  </div>
                  <div className="setting-card">
                    <div className="change-avatar img-upload">
                      <div className="profile-img">
                        {profileData.profilepicture ? (
                          <img
                            src={profileData.profilepicture}
                            alt="Profile"
                            className="img-fluid rounded-circle"
                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                            onError={(e) => {
                              e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='12' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E";
                            }}
                          />
                        ) : (
                          <i className="fa-solid fa-user" style={{ fontSize: '48px' }} />
                        )}
                      </div>
                      <div className="upload-img">
                        <h5>Profile Image</h5>
                        <div className="form-wrap">
                          <label className="col-form-label">Upload New Picture</label>
                          <input
                            type="file"
                            className="form-control"
                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                            onChange={handleFileChange}
                            disabled={uploading}
                          />
                          {uploading && (
                            <div className="mt-2">
                              <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                <span className="visually-hidden">Uploading...</span>
                              </div>
                              <small className="text-muted">Uploading image...</small>
                            </div>
                          )}
                        </div>
                        <p className="form-text">
                          Select an image file (JPG, PNG only). Max size: 5MB
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Personal Information */}
                  <div className="setting-title">
                    <h5>Personal Information</h5>
                  </div>
                  <div className="setting-card">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-wrap">
                          <label className="col-form-label">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="fullName"
                            value={profileData.fullName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-wrap">
                          <label className="col-form-label">
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="userPhone"
                            value={profileData.userPhone}
                            onChange={handleInputChange}
                            readOnly
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-wrap">
                          <label className="col-form-label">
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={profileData.email}
                            onChange={handleInputChange}
                            readOnly
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-wrap">
                          <label className="col-form-label">
                            Date of Birth
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="dob"
                            value={profileData.dob}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Favorite Entertainment */}
                  <div className="setting-title">
                    <h5>Favorite Entertainment</h5>
                  </div>
                  <div className="setting-card">
                    <div className="form-wrap">
                      <label className="col-form-label">
                        Favorite Entertainment Types
                      </label>
                      <TagsInput
                        value={profileData.favoriteentertainment}
                        onChange={(tags) => setProfileData(prev => ({ ...prev, favoriteentertainment: tags }))}
                        placeHolder="Add entertainment types (press Enter)"
                      />
                    </div>
                  </div>

                  {/* Social Media Links */}
                  <div className="setting-title">
                    <h5>Social Media Links</h5>
                  </div>
                  <div className="setting-card">
                    {profileData.socialmedialinks.map((link, index) => (
                      <div className="row mb-3" key={index}>
                        <div className="col-md-5">
                          <div className="form-wrap">
                            <label className="col-form-label">Platform</label>
                            <input
                              type="text"
                              className="form-control"
                              value={link.platform}
                              onChange={(e) => handleSocialLinkChange(index, 'platform', e.target.value)}
                              placeholder="Platform name"
                            />
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="form-wrap">
                            <label className="col-form-label">URL</label>
                            <input
                              type="url"
                              className="form-control"
                              value={link.url}
                              onChange={(e) => handleSocialLinkChange(index, 'url', e.target.value)}
                              placeholder="https://..."
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <label className="col-form-label">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm w-100"
                            onClick={() => removeSocialLink(index)}
                            style={{ marginTop: '30px' }}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}

                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={addSocialLink}
                    >
                      + Add Social Media Link
                    </button>
                  </div>

                  {/* Submit Buttons */}
                  <div className="modal-btn text-end mt-4">
                    <Link to="/fan-dashboard" className="btn btn-gray me-2">
                      Cancel
                    </Link>
                    <button
                      type="submit"
                      className="btn btn-primary prime-btn"
                      disabled={loading || uploading}
                    >
                      {loading ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer {...props} />
    </div>
  );
};

export default Profile;

